module.exports = __webpack_public_path__ + "static/media/caffeSiideBanner.6a363b11.jpeg";